<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" :size="size">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.versionState"
        placeholder="发布状态"
      >
        <el-option
          v-for="(item, i) in versionStateMap"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.versionType"
        placeholder="版本类型"
      >
        <el-option
          v-for="(item, i) in versionTypeMap"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        clearable
        prefix-icon="el-icon-search"
        v-model="filters.versionCode"
        placeholder="版本编号"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
export default {
  name: "search",
  components: {
    butn,
  },
  data() {
    return {
      size: "small",
      versionTypeMap: [],
      versionStateMap: [],
      filters: undefined,
    };
  },
  created() {
    this.getSysParamByTypes(["VERSION_TYPE", "VERSION_STATE"]);
    const emptyObj = Object.create(null);
    this.filters = emptyObj;
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        res.data["VERSION_TYPE"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["VERSION_STATE"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        this.versionTypeMap = res.data["VERSION_TYPE"] || [];
        this.versionStateMap = res.data["VERSION_STATE"] || [];
      });
    },
    initData() {
      //查询
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      //重置
      this.pid = [];
      this.filters = {};
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>
